"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Builder["default"];
  }
});
var _Builder = _interopRequireDefault(require("../../components/Builder"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }